// extracted by mini-css-extract-plugin
module.exports = {"root":"v9Oc8Flb","icon":"_4jorOEyZ"};